<template>
  <div class="ma-wrap">
    <ProgressBar v-if="loader" mode="indeterminate"
      style="height:3px;position:fixed;top:0;left:0;right:0;z-index:9999;border-radius:0"/>

    <!-- ── Topbar ── -->
    <div class="ma-topbar">
      <div>
        <h2 class="ma-title">Motivos Anulación</h2>
        <p class="ma-sub">Catálogo de motivos para anular viajes</p>
      </div>
      <button class="ma-btn-primary" @click="openModalMotivo">
        <i class="pi pi-plus"></i> Nuevo motivo
      </button>
    </div>

    <!-- ── Tabla ── -->
    <div class="ma-tabla-wrap">
      <table class="ma-tabla">
        <thead>
          <tr>
            <th>Descripción</th>
            <th style="width:110px;text-align:center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="motivos_anulacion.length === 0 && !loader">
            <td colspan="2" class="ma-empty">
              <i class="pi pi-ban"></i>
              <p>No hay motivos de anulación configurados</p>
            </td>
          </tr>
          <tr v-for="(item, i) in motivos_anulacion" :key="i">
            <td>
              <div class="ma-item-name">{{ item.descripcion }}</div>
            </td>
            <td style="text-align:center">
              <div class="ma-acciones">
                <button class="ma-btn-icon" title="Editar" @click="editar_motivo(item)">
                  <i class="pi pi-pencil"></i>
                </button>
                <button class="ma-btn-icon ma-btn-icon--danger" title="Eliminar"
                        @click="eliminar_motivo(item)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <template v-if="loader && motivos_anulacion.length === 0">
        <div class="ma-skeleton-wrap">
          <div v-for="n in 5" :key="n" class="ma-skeleton-row"></div>
        </div>
      </template>

      <div class="ma-pagination">
        <span>{{ pagination.from }}–{{ pagination.to }} de {{ pagination.total }} motivos</span>
        <Paginator :first="pagination.from" :rows="pagination.per_page"
          :rowsPerPageOptions="[15]" :totalRecords="pagination.total"
          @page="onChangePage($event)" class="ma-paginator" />
      </div>
    </div>

    <!-- ══ MODAL CREAR / EDITAR ══ -->
    <Dialog v-model:visible="modal_motivo" :style="{width:'480px'}"
            header="Motivo de anulación" :modal="true" class="ma-dialog">
      <div class="ma-modal-body">
        <div class="ma-form-field">
          <label>Descripción <span class="ma-required">*</span></label>
          <InputText v-model="frmMotivo.descripcion"
            placeholder="Ej: Cancelación del cliente"
            :class="{'p-invalid': submitted && !frmMotivo.descripcion}" />
          <span class="ma-error" v-if="submitted && !frmMotivo.descripcion">
            La descripción es requerida
          </span>
        </div>
      </div>
      <template #footer>
        <button class="ma-btn-outline" @click="modal_motivo = false">
          <i class="pi pi-times"></i> Cancelar
        </button>
        <button class="ma-btn-primary" :disabled="loader" @click="guardar_item">
          <i :class="frmMotivo.id ? 'pi pi-pencil' : 'pi pi-save'"></i>
          {{ frmMotivo.id ? 'Guardar cambios' : 'Crear motivo' }}
        </button>
      </template>
    </Dialog>

    <!-- ══ MODAL ELIMINAR ══ -->
    <Dialog v-model:visible="deleteMotivo" :style="{width:'420px'}"
            header="Eliminar motivo de anulación" :modal="true" class="ma-dialog">
      <div class="ma-modal-body">
        <div class="ma-confirm-body">
          <div class="ma-confirm-icon ma-confirm-icon--danger">
            <i class="pi pi-trash"></i>
          </div>
          <div>
            <p class="ma-confirm-q">¿Eliminar este motivo de anulación?</p>
            <p class="ma-confirm-sub">
              Esta acción no se puede deshacer. El motivo dejará de aparecer en
              el select del modal de anular viaje.
            </p>
          </div>
        </div>
      </div>
      <template #footer>
        <button class="ma-btn-outline" @click="deleteMotivo = false">
          <i class="pi pi-times"></i> Cancelar
        </button>
        <button class="ma-btn-danger" :disabled="loader" @click="deleteMotivoAnulacion">
          <i class="pi pi-trash"></i> Eliminar
        </button>
      </template>
    </Dialog>

  </div>
</template>

<script>
export default {
	data() {
		return {
			motivos_anulacion: [],
			loader: false,
			submitted: false,
			modal_motivo: false,
			deleteMotivo: false,
			frmMotivo: {},
			id_motivo_seleccionado: null,
			pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
		}
	},
	mounted(){
		this.loadMotivosAnulacion(1);
	},
	methods:{
		loadMotivosAnulacion(page){
			this.loader = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.motivos_anulacion = [];
			window.api.call('post', '/load_motivos_anulacion?&page='+page, {email: email,id_rol: id_rol}).then( function(response) {
				if(response.status == 200){
					_that.pagination = response.data.data;
					_that.motivos_anulacion = response.data.data.data;
					_that.loader = false;
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
				_that.$toast.add({severity:'error', summary: 'Ocurrio un error al cargar', detail:'Favor informar a un admin', life: 6000});
			});
		},
		onChangePage(page) {
			this.loadMotivosAnulacion((page.page+1));
		},
		openModalMotivo(){
			this.submitted = false;
			this.modal_motivo = true;
			this.frmMotivo.id = 0;
			this.frmMotivo.descripcion = '';
		},
		editar_motivo(data){
			this.submitted = false;
			this.modal_motivo = true;
			this.frmMotivo = { ...data };
		},
		guardar_item(){
			if(!this.frmMotivo.descripcion){
				this.loader = false;
				this.submitted = true;
				this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor ingresar una descripción', life: 4000});
				return
			}
			this.loader = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			window.api.call('post', '/guardar_item_motivo_anulacion', {email: email,id_rol: id_rol,frmMotivo: this.frmMotivo}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.modal_motivo = false;
					_that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Se guardó el motivo con éxito', life: 6000 });
					_that.pagination = response.data.data;
					_that.motivos_anulacion = response.data.data.data;
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
				_that.$toast.add({severity:'error', summary: 'Ocurrio un error al guardar', detail:'Favor informar a un admin', life: 6000});
			});
		},
		eliminar_motivo(data){
			this.deleteMotivo = true;
			this.id_motivo_seleccionado = data.id;
		},
		deleteMotivoAnulacion(){
			this.loader = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			window.api.call('post', '/eliminar_item_motivo_anulacion', {email: email,id_rol: id_rol,id_motivo_anulacion: this.id_motivo_seleccionado}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.deleteMotivo = false;
					_that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Se eliminó el motivo con éxito', life: 6000 });
					_that.pagination = response.data.data;
					_that.motivos_anulacion = response.data.data.data;
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
				_that.$toast.add({severity:'error', summary: 'Ocurrio un error al eliminar', detail:'Favor informar a un admin', life: 6000});
			});
		}
	},
	computed: {
			isRTL() {
				return this.$appState.RTL;
			}
		}
}
</script>

<style scoped lang="scss">
$navy:#0A354E; $white:#fff; $g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px; $bg:#f7f7f7;

.ma-wrap { background:$bg; min-height:100vh; padding:1.25rem .5rem; }

/* ── Topbar ── */
.ma-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:1.25rem; flex-wrap:wrap; gap:.75rem; }
.ma-title  { font-size:1.35rem; font-weight:700; color:$g700; margin:0 0 .2rem; }
.ma-sub    { font-size:.8rem; color:$g500; margin:0; }

/* ── Buttons ── */
.ma-btn-primary { display:inline-flex; align-items:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.ma-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:all .15s; i{font-size:13px;} &:hover{border-color:$navy;color:$navy;} }
.ma-btn-danger   { display:inline-flex; align-items:center; gap:.35rem; background:#dc2626; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; &:hover{background:#b91c1c;} &:disabled{opacity:.6;cursor:not-allowed;} }
.ma-btn-icon     { display:inline-flex; align-items:center; justify-content:center; width:30px; height:30px; background:$white; border:1px solid $g200; border-radius:6px; cursor:pointer; color:$g700; font-size:.8rem; transition:all .15s; &:hover{border-color:$navy;color:$navy;} }
.ma-btn-icon--danger { &:hover{border-color:#dc2626;color:#dc2626;} }

/* ── Tabla ── */
.ma-tabla-wrap { background:$white; border:1px solid $g200; border-radius:$r; overflow:hidden; }
.ma-tabla { width:100%; border-collapse:collapse; font-size:.82rem; }
.ma-tabla thead tr { background:#f8f9fa; }
.ma-tabla th { text-align:left; padding:.65rem 1rem; font-size:.63rem; font-weight:700; letter-spacing:.7px; text-transform:uppercase; color:$g500; border-bottom:1px solid $g200; white-space:nowrap; }
.ma-tabla td { padding:.75rem 1rem; border-bottom:1px solid #f1f3f4; color:$g700; vertical-align:middle; }
.ma-tabla tbody tr:last-child td { border-bottom:none; }
.ma-tabla tbody tr:hover td { background:#fafbfc; }

.ma-item-name { font-weight:600; font-size:.85rem; color:$g700; }
.ma-acciones  { display:flex; gap:.4rem; justify-content:center; }

/* ── Paginación ── */
.ma-pagination { display:flex; justify-content:space-between; align-items:center; padding:.75rem 1rem; border-top:1px solid $g200; font-size:.78rem; color:$g500; }
.ma-paginator  { background:transparent; border:none; }

/* ── Empty / skeleton ── */
.ma-empty { text-align:center; padding:3rem !important; color:$g500; i{font-size:1.75rem;display:block;margin-bottom:.75rem;} p{font-size:.875rem;margin:0;} }
@keyframes shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
.ma-skeleton-wrap { padding:1rem; }
.ma-skeleton-row  { height:56px; border-radius:8px; background:linear-gradient(90deg,#ececec 25%,#f5f5f5 50%,#ececec 75%); background-size:1200px; animation:shimmer 1.4s infinite linear; margin-bottom:.5rem; }

/* ── Modal ── */
.ma-dialog {
  :deep(.p-dialog-header){ font-weight:700; font-size:1rem; border-bottom:1px solid $g200; }
  :deep(.p-dialog-content){ padding:1.5rem; }
  :deep(.p-dialog-footer){ border-top:1px solid $g200; padding:1rem 1.5rem; display:flex; justify-content:flex-end; gap:.65rem; }
}

.ma-modal-body { display:flex; flex-direction:column; gap:1.25rem; }
.ma-form-field { display:flex; flex-direction:column; gap:.3rem; label{font-size:.72rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.ma-required { color:#ef4444; }
.ma-error    { font-size:.72rem; color:#dc2626; margin-top:.1rem; }

/* Confirmar eliminar */
.ma-confirm-body    { display:flex; align-items:flex-start; gap:1rem; padding:.5rem; }
.ma-confirm-icon    { width:48px; height:48px; border-radius:12px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.3rem;} }
.ma-confirm-icon--danger { background:#fef2f2; i{color:#dc2626;} }
.ma-confirm-q   { font-size:.9rem; font-weight:600; color:$g700; margin:0 0 .35rem; }
.ma-confirm-sub { font-size:.82rem; color:$g500; margin:0; line-height:1.4; }
</style>
